import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { UserService } from '../../shared/services/user.service';
import { BookingStatus, UserBookingService } from '../../shared/services/user-booking.service';
import { Booking } from '../..//shared/models/booking.model';
import { Utilities } from '../../shared/utilities/utilities';
import { LanguageService } from '../../shared/services/language.service';


@Component({
  templateUrl: 'bookings-confirmation.component.html',
  styleUrls: ['bookings-confirmation.component.scss']
})
export class BookingsConfirmationComponent implements OnInit, OnDestroy {

  public booking: Booking;
  public confirmationTitle: string;
  public requireApproval: boolean;
  private languageSubscription: Subscription;
  
  constructor(private userService: UserService,
    private userBookingService: UserBookingService,
    private languageService: LanguageService,
    private router: Router) {
    this.booking = this.userBookingService.getBooking().clone();
    this.userBookingService.resetBooking();
    this.refreshConfirmationTitle(this.languageService.getCurrentLanguage());
  }

  public ngOnInit () {
    this.languageSubscription = this.languageService.currentLanguage$.subscribe((lang: string) => {
      this.refreshConfirmationTitle(lang);
    });
    if (this.userService.isLoggedIn() === false ||
      ((this.booking.getStatus() === BookingStatus.Requested || this.booking.getStatus() === BookingStatus.Unconfirmed || this.booking.getStatus() === BookingStatus.WaitList) && this.booking.getServices().length === 0)) {
      this.newBookings();
    }
    this.requireApproval = this.booking.getStatus() === BookingStatus.Requested;
    if (!this.requireApproval) {
      for (var service of this.booking.getServices()){
        if(service.getStylist()?.getConfirmApptsManually() === 1){
          this.requireApproval = true;
          break;
        }
      }
    }
  }

  public newBookings () {
    this.router.navigate(['/']);
  }

  public ngOnDestroy(): void {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  private refreshConfirmationTitle(lang: string): void {
    this.confirmationTitle = Utilities.formatDate(
      this.booking.getStartDateTime(),
      'h:mm a, EEEE, MMMM d, yyyy',
      lang
    );
  }

}
